import 'lazysizes'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import 'intersection-observer'
import 'promise-polyfill/src/polyfill'
import WebFont from 'webfontloader'
import emitter from './utils/emitter'
import { createComponent } from '@bigyouth/base'
import objectFitImages from 'object-fit-images'

import './polyfills'
import './assets'

import './style/styles.scss'
import * as features from './features'

Object.values(features).forEach(createComponent)

objectFitImages()

WebFont.load({
  // google or custom font, exemple for custom: custom: {families: ['Locator:n2,n3,n4,n5,n6'],},
  custom: {
    families: [
      'AvantGardeGothicITC',
      'EuclidFlex',
      'NEXTMono-Thin',
    ],
  },
  active: function () {
    sessionStorage.fonts = true
    document.documentElement.classList.add('wf-active')
    emitter.trigger('WEBFONT_LOADED')
  },
})

setTimeout(() => {
  if (document.querySelector('.animate-bg')) {
    document.querySelector('.animate-bg').classList.add('animated-bg')
  }
}, 500)
